export const showPriceAreaSelector = ({showPriceArea}) => showPriceArea